import { BYTES_PER_GIGABYTE, BYTES_PER_KILOBYTE, BYTES_PER_MEGABYTE } from './bytes.constants';

// Maximum bytes per file, shared by frontend validation and backend enforcement.
export const MAX_UPLOAD_SIZE_AVATAR_PICTURE = 512 * BYTES_PER_KILOBYTE;
export const MAX_UPLOAD_SIZE_PERFORMANCE_VISUALIZATION = 512 * BYTES_PER_KILOBYTE;
export const MAX_UPLOAD_SIZE_TENANT_LOGO = BYTES_PER_MEGABYTE;
export const MAX_UPLOAD_SIZE_EXTERNAL_MATERIAL_LOGO = BYTES_PER_MEGABYTE;
export const MAX_UPLOAD_SIZE_REPORT_COVER_IMAGE = BYTES_PER_MEGABYTE;
export const APPEARANCE_IMAGE_MAX_BYTES = BYTES_PER_MEGABYTE;
export const MAX_UPLOAD_SIZE_THUMBNAIL = 128 * BYTES_PER_KILOBYTE;
export const ENTRY_ATTACHMENT_MAX_BYTES = 20 * BYTES_PER_MEGABYTE;
// Fallback for multipart uploads, currently used by the provider school import (100 MB).
export const MAX_UPLOAD_SIZE_DEFAULT = 100_000_000;

// Frontend selection cap, including files already pending in the draft; not a total per entry.
export const ENTRY_ATTACHMENT_MAX_FILES_PER_SELECTION = 5;

// Unexpired upload permits and completed files still waiting to be linked.
export const MAX_ACTIVE_UPLOADS_PER_USER = 100;
export const MAX_ACTIVE_UPLOADS_PER_TENANT = 500;

export const UPLOAD_FILENAME_MAX_LENGTH = 255;
export const ENTRY_ATTACHMENT_MAX_FILES_PER_ENTRY = 50;
export const ENTRY_ATTACHMENT_PAGE_SIZE = 50;

// Admission counts stored files (including deletion backlog) and temporary upload reservations.
export const MAX_STORED_BYTES_PER_USER = 5 * BYTES_PER_GIGABYTE;
export const MAX_STORED_BYTES_PER_TENANT = 50 * BYTES_PER_GIGABYTE;
export const MAX_STORED_FILES_PER_USER = 10_000;
export const MAX_STORED_FILES_PER_TENANT = 100_000;

// Each API process bounds its own memory and database work, independently of route request rates.
export const FILE_UPLOAD_REQUESTS_PER_MINUTE = 60;
export const MAX_CONCURRENT_FILE_COMPLETIONS = 8;
export const MAX_CONCURRENT_FILE_COMPLETIONS_PER_USER = 5;
export const FILE_COMPLETION_TIMEOUT_MS = 45_000;
export const FILE_STORAGE_REQUEST_TIMEOUT_MS = 30_000;
// Image linking only inspects this prefix; completion never downloads the object body.
export const IMAGE_TYPE_HEADER_MAX_BYTES = 4 * BYTES_PER_KILOBYTE;

// nginx limits an upload request to 1 MiB, the size upload errors name; a file sent alone keeps 1 KiB of it for the
// multipart overhead.
export const MAX_UPLOAD_REQUEST_SIZE = BYTES_PER_MEGABYTE;
const MAX_SINGLE_FILE_UPLOAD_SIZE = MAX_UPLOAD_REQUEST_SIZE - BYTES_PER_KILOBYTE;

// Maximum compressed ZIP size. The client sends a fixed filename and MIME type; ZIP metadata is already in file.size.
export const MAX_ZIP_SIZE_TEMPLATE_SET = MAX_SINGLE_FILE_UPLOAD_SIZE;
export const MAX_UNPACKED_SIZE_TEMPLATE_SET = 5 * BYTES_PER_MEGABYTE;
export const MAX_UPLOAD_SIZE_STUDENT_IMPORT = MAX_SINGLE_FILE_UPLOAD_SIZE;
